import { gql, type TypedDocumentNode } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Link } from '@sorare/routing';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandXS, LabelM } from '@sorare/core/src/atoms/typography';
import {
  ANY_SPORT_SERIES_MISSIONS_PLAY,
  ANY_SPORT_SERIES_PLAY,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';
import { glossary } from '@sorare/core/src/lib/glossary';

import { MissionToastBackground } from '#src/components/missions/CurrentUserTaskUpdatedToast/MissionToast/MissionToastBackground/index.tsx';

import type { DailyBoostToastContent_task } from './__generated__/index.graphql.ts';

type Props = { task: DailyBoostToastContent_task; onClose: () => void };
export const DailyBoostToastContent = ({ task, onClose }: Props) => {
  const { parentTask, title } = task;
  const { generateSportContextPath } = useSportContext();
  const isDesktop = useIsDesktopAndAbove();

  return (
    <Link
      draggable={false}
      to={
        isDesktop
          ? generateSportContextPath(ANY_SPORT_SERIES_PLAY)
          : generateSportContextPath(ANY_SPORT_SERIES_MISSIONS_PLAY)
      }
      onClick={onClose}
    >
      <MissionToastBackground color="#7029FF" showHalo>
        <SBHorizontal>
          <Vertical>
            <BrandXS color="var(--c-nd-600)">{parentTask?.title}</BrandXS>
            <LabelM bold>{title}</LabelM>
          </Vertical>
          <Button color="primary" size="compact" asSpan>
            <FormattedMessage {...glossary.claim} />
          </Button>
        </SBHorizontal>
      </MissionToastBackground>
    </Link>
  );
};

DailyBoostToastContent.fragments = {
  task: gql`
    fragment DailyBoostToastContent_task on Task {
      id
      title
      parentTask {
        id
        title
      }
    }
  ` as TypedDocumentNode<DailyBoostToastContent_task>,
};
